import { render, staticRenderFns } from "./SupplierSelectionForm.vue?vue&type=template&id=9b936b42&scoped=true&"
import script from "./SupplierSelectionForm.vue?vue&type=script&lang=js&"
export * from "./SupplierSelectionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b936b42",
  null
  
)

export default component.exports